import React, {Component} from 'react';
import {connect} from 'react-redux';

class PlayerInjury extends Component {
    render() {
        const {player} = this.props;

        if (!player.injury) {
            return null;
        }

        return <span className="has-injury"> {player.injury}</span>;
    }
}

export default PlayerInjury;
